import { Fragment } from "react";

import { define, prop } from "@/components/builder/utils";

import BasePreview from "../../base";

function MidpathTCPAAnswerCheckbox(props) {
  return <BasePreview {...props}>
    <input type="checkbox"></input>
  </BasePreview>
}

export default define('tcpa-item-answer-checkbox', MidpathTCPAAnswerCheckbox, Fragment)
  .shared(prop.share('MidpathTCPAAnswerCheckbox', 'tcpa-item-answer-checkbox'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .build()
